(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function openEl(el) {
    if (!el) return;
    el.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove("is-open");
    if (!$(".drawer.is-open") && !$(".search-overlay.is-open")) {
      document.body.style.overflow = "";
    }
  }

  const nav = $("#NavDrawer");
  const cart = $("#CartDrawer");
  const search = $("#SearchOverlay");

  $$("[data-open-nav]").forEach((b) => b.addEventListener("click", () => openEl(nav)));
  $$("[data-open-cart]").forEach((b) =>
    b.addEventListener("click", () => {
      refreshCart();
      openEl(cart);
    }),
  );
  $$("[data-open-search]").forEach((b) => {
    b.addEventListener("click", () => {
      openEl(search);
      const input = $("input[type=search]", search);
      if (input) setTimeout(() => input.focus(), 30);
    });
  });
  $$("[data-close]").forEach((b) =>
    b.addEventListener("click", () => {
      closeEl(nav);
      closeEl(cart);
      closeEl(search);
    }),
  );
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeEl(nav);
      closeEl(cart);
      closeEl(search);
    }
  });

  $$("[data-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const src = btn.getAttribute("data-thumb");
      const stage = $("#ProductStage");
      if (stage && src) {
        const img = $("img", stage);
        if (img) img.src = src;
      }
      $$("[data-thumb]").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
    });
  });

  async function refreshCart() {
    if (!cart) return;
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();
      $$("[data-cart-count]").forEach((n) => {
        n.textContent = String(data.item_count);
        n.hidden = data.item_count === 0;
      });
      const body = $("[data-cart-body]", cart);
      const foot = $("[data-cart-foot]", cart);
      if (!body) return;
      if (!data.items.length) {
        body.innerHTML =
          '<div class="empty"><p class="font-display" style="font-size:1.85rem">Your bag is at rest.</p><p class="fine">When you’re ready, the coast will still be here.</p></div>';
        if (foot) foot.hidden = true;
        return;
      }
      body.innerHTML = data.items
        .map(
          (item) => `
        <div class="cart-line">
          <img src="${item.image || ""}" alt="">
          <div>
            <a href="${item.url}">${item.product_title}</a>
            <p class="fine">${item.variant_title || ""}</p>
            <p>${formatMoney(item.final_line_price)}</p>
            <div class="qty">
              <button type="button" data-qty="${item.key}" data-next="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty="${item.key}" data-next="${item.quantity + 1}">+</button>
            </div>
          </div>
        </div>`,
        )
        .join("");
      if (foot) {
        foot.hidden = false;
        const sub = $("[data-cart-subtotal]", foot);
        if (sub) sub.textContent = formatMoney(data.total_price);
      }
      body.querySelectorAll("[data-qty]").forEach((btn) => {
        btn.addEventListener("click", async () => {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: btn.getAttribute("data-qty"),
              quantity: Number(btn.getAttribute("data-next")),
            }),
          });
          refreshCart();
        });
      });
    } catch (err) {
      console.warn("Cart refresh skipped", err);
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "USD",
      minimumFractionDigits: 0,
    });
  }

  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains("product-form") && !form.hasAttribute("data-ajax-cart")) return;
    e.preventDefault();
    const fd = new FormData(form);
    try {
      await fetch("/cart/add.js", { method: "POST", body: fd });
      refreshCart();
      openEl(cart);
    } catch (err) {
      form.submit();
    }
  });

  refreshCart();
})();
